import { useRef } from 'react';
import { useCreators } from './use-creators';
import { useMinLoading } from '@/hooks/use-min-loading';

type LeadsState = {
  state: 'loading' | 'data' | 'empty';
  data: ReturnType<typeof useCreators>['data'];
  isFetching: boolean;
  isPlaceholderData: boolean;
};

export function useCreatorsState(): LeadsState {
  const query = useCreators();
  const firstLoad = useMinLoading(query.isLoading && !query.data);
  const hadData = useRef(false);
  const items = query.data?.items ?? [];
  if (items.length > 0) hadData.current = true;
  const showTable = hadData.current || items.length > 0;
  const state = firstLoad ? 'loading' : showTable ? 'data' : 'empty';
  return {
    state,
    data: query.data,
    isFetching: query.isFetching,
    isPlaceholderData: query.isPlaceholderData,
  };
}
